import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import withRouter from 'react-router/lib/withRouter';
import ProfileMenu from '../components/ProfileMenu';

class Profile extends Component {

    componentWillMount() {
        const { getProfile, checkFirstTime } = this.props;
        checkFirstTime();
        getProfile();
    }

    render(){

    	const { children, profile, location } = this.props;

		return (
            <div className="page_content">
    			<div className="row">
                    <div className="col-md-4 col-xs-12">
                        <ProfileMenu data={ profile } location={ location }/>
                    </div>
                    <div className="col-md-8 col-xs-12">
                        { children }
                    </div>
                </div>
            </div>
		)
	}
}

export default withRouter(connect(
	(state, routeParams) => {
		const { profile } = state.profile;
        const { params, location } = routeParams;


		return {
            params, profile, location
		}
	},
	actions
)(Profile))


// WEBPACK FOOTER //
// ./src/profile/containers/Profile.js